import React from 'react';
import Moment from 'react-moment';
import moment from 'moment';
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

export const VisitE025Details = ({ e025List, e025Ref, handleFileDownload }) => {
  if (!Array.isArray(e025List) || e025List.length === 0) return null;

  return (
    <div ref={e025Ref} className="mt-3">
      {e025List.map((e025, index) => (
        <Card key={index} className="mb-4">
          <CardHeader>
            <Heading variant="userAccountDetailsTitle">
              Ambulatorinio apsilankymo aprašymas
            </Heading>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <span>Data: </span>
              <span>
                {new Date(Date.parse(e025.date)).getUTCHours() === 0 ? (
                  <Moment utc format="YYYY-MM-DD">
                    {Date.parse(e025.date)}
                  </Moment>
                ) : (
                  <Moment utc format="YYYY-MM-DD HH:mm">
                    {Date.parse(e025.date)}
                  </Moment>
                )}
              </span>
            </div>

            <div>
              <span>Laikas: </span>
              <Moment utc parse="HH:mm" format="HH:mm">
                {e025.time}
              </Moment>
            </div>

            <div>
              <span>Gydytojas: </span>
              <span>
                {e025.practitioner.qualification} - {e025.practitioner.name}{' '}
                {e025.practitioner.surname}
              </span>
            </div>

            <div>
              <span>Nusiskundimai ir anamnezė: </span>
              {e025.complaints?.split(/\r?\n|<br\/>/).map((text, i) => (
                <span key={i}>{text}</span>
              ))}
            </div>

            <div>
              <span>Objektyvi būklė: </span>
              {e025.objectiveCondition?.split(/\r?\n|<br\/>/).map((text, i) => (
                <span key={i}>{text}</span>
              ))}
            </div>

            <div>
              <span>Atlikti tyrimai ir konsultacijos: </span>
              {e025.finishedDiagnosticReports
                ?.split(/;|\r?\n|<br\/>/)
                .map((text, i) => (
                  <span key={i}>{text}</span>
                ))}
            </div>

            <div>
              <span>Tyrimų ir konsultacijų planas: </span>
              {e025.plannedDiagnosticReports
                ?.split(/\r?\n|<br\/>/)
                .map((text, i) => (
                  <span key={i}>{text}</span>
                ))}
            </div>

            <div>
              <span>Taikytas gydymas: </span>
              {e025.carePlan
                ?.split(/\r?\n|<br\/>/)
                .map((text, i) => <span key={i}>{text}</span>) || <br />}
            </div>

            <div>
              <span>Taikytas medikamentinis gydymas: </span>
              {e025.medicationStatement
                ?.split(/\r?\n|<br\/>/)
                .map((text, i) => <span key={i}>{text}</span>) || <br />}
            </div>

            <div>
              <span>Rekomendacijos: </span>
              {e025.recommendations?.split(/\r?\n|<br\/>/).map((text, i) => (
                <span key={i}>{text}</span>
              ))}
            </div>

            {e025.file?.guid && (
              <div>
                <Button
                  variant="light"
                  onClick={() => {
                    const fileName = `${e025.practitioner.qualification}-${
                      e025.practitioner.name
                    } ${e025.practitioner.surname} ${moment(e025.date).format(
                      'YYYY-MM-DD',
                    )}`;
                    handleFileDownload(
                      'e025',
                      fileName,
                      e025.file.type,
                      e025.file.guid,
                    );
                  }}
                >
                  <Download />
                  Atsisiųsti PDF
                </Button>
              </div>
            )}
          </CardContent>
          <CardFooter />
        </Card>
      ))}
    </div>
  );
};
